//=include  ../dataLayer.js
import DataLayer from '../dataLayer'
export default class HeaderTracker {


    constructor() {
        this.analytics = window.__pt.fn.analytics;
        this.settings = window.__pt.settings;
        this.events = window.__pt.fn.analytics.events;
        this.cultureData = window.__pt.cultureData;
        this.pages = window.__pt.fn.analytics.pages;
    }

    metricLoginAction(fn, arg) {
        const { action, userId } = arg;
        const objMetric = {
            event: this.events.gtmEvent,
            eventName: "login",
            eventCategory: "login",
            eventAction: action,
            eventLabel: '',
            eventExtra: '',
            userId: userId || window.__pt.user?.id || "",
        }
        this.analytics.set(objMetric.event, objMetric);
    }

    metricCallYouAction(arg) {
        const { action } = arg;
        const page = this.settings.page || "blank";
        const objMetric = {
            event: this.events.gtmEvent,
            eventName: "nosotros-llamamos",
            eventCategory: "nosotros-llamamos",
            eventAction: action,
            eventLabel: 'page:' + page
        }
        this.analytics.set(objMetric.event, objMetric);
    }

    newsLetter(email) {
        const objMetric = {
            event: "newsletterSubscription",
            newsletterUser: email,
        }
        this.analytics.set(objMetric.event, objMetric);
    }
    metricHeaderSelectContent(arg) {
        const { title } = arg;
        const objMetric = {
            content_type: this.events.button,
            element: `header :: ${title}`,
            event: this.events.trackEvent,
            eventName: this.events.selectContent,
            layer: this.settings.page
        }
        this.analytics.set(objMetric.event, objMetric);
    }

    metricHeaderSelectModalOption(arg) {
        const { title, currency, language } = arg;
        const objMetric = {
            content_type: this.events.button,
            element: `header :: ${title} :: ${language ? language : this.cultureData.cultureCode}-${currency ? currency : this.cultureData.currency}`,
            event: this.events.trackEvent,
            eventName: this.events.selectContent,
            layer: this.settings.page
        }
        this.analytics.set(objMetric.event, objMetric);
    }

    metricHeaderSelectContentLanguageModal(arg) {
        const { title } = arg;
        const objMetric = {
            content_type: this.events.button,
            element: `form :: ${title}`,
            event: this.events.trackEvent,
            eventName: this.events.selectContent,
            layer: this.settings.page,
            page_type: this.pages[this.settings.page],
            extra_info: `${this.cultureData.cultureCode}|${this.cultureData.currency}`
        }
        this.analytics.set(objMetric.event, objMetric);
    }
    metricsErrorsLogin(key) {
        const objMetric = {
            event: this.events.gtmEvent,
            eventAction: "login error",
            eventCategory: "login",
            eventName: "login",
            eventLabel: `${key}`
        }
        this.analytics.set(objMetric.event, objMetric);
    }
}
